/**
 * @file   src\Pages\SignIn.tsx
 * @brief  SignIn page.
 * @date   JUL, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React,Button, Link, useLocation, useNavigate, useState } from '../utils/thirdpartyComponents';
import Carwashlogo from '../assets/images/CarWash-Logo.svg';
import CWPasswordInput from '../components/CWPasswordInput';
import '../styles/signin.scss';
import * as Yup from 'yup'
import { PASSWORD_MAX_LENGTH } from '../utils/constants';
import { FORGOTPASSWORD_STEP3_SCHEMA } from '../validations/forgotPasswordSchema';
import { pageURLs } from '../utils/pageUrls';
import axios from '../config/axiosConfig';
import { MessageToaster } from '../utils/toastUtil';
import { AuthApi } from '../utils/apiUrls';
import { userType } from '../utils/enums';
import FullLoader from '../components/FullLoader';
const ForgotPasswordStep3 = (props:any) => {
    const {state} = useLocation()
    // Toast object creation.
    const toaster = new MessageToaster();
    const navigate = useNavigate()
    // Initialize states for formdata
    const [formData, setFormData] = useState({
        newpassword: '',
        typepassword: '',

    })
    const [loading, setLoading] = useState(false);

    // Handle errors
    const [errors, setErrors] = useState({
        newpassword: '',
        typepassword: '',
    });

    // Triggers when passord is entered
    const onPasswordChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;

        // To remove validation when user enters input
        const keys = Object.keys(errors);
        if (keys.includes(name)) {
            setErrors({
                ...errors,
                [name]: ""
            })
        }

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        try {
            // Validate form data
            await FORGOTPASSWORD_STEP3_SCHEMA.validate(formData, { abortEarly: false });
            try {
                setLoading(true)
                //join the otp values
                const requestData ={resetToken:state.resetToken,
                    password:formData.newpassword,
                    confirmpassword:formData.typepassword

                }
                const { data } = await axios.post(AuthApi.RESET_PASSWORD,requestData);
                if (data?.error == 0) {
                    setLoading(false)
                    toaster.toastSuccess(data?.message);
                    if(props.userType == userType['SUPER-ADMIN'])
                    navigate(`/superadmin/${pageURLs.root}`)
                    else
                    navigate(`/`)
                }
                else {
                    setLoading(false)
                    // show error message
                    toaster.toastError(data?.message);
                }
            } catch (error: any) {
                throw new Error(error?.response?.data?.message || error?.message);
            }

        } catch (error) {

            //If validation fails on submit, then errors are shown
            if (error instanceof Yup.ValidationError) {
                const newErrors: any = {};
                error.inner.forEach((err) => {
                    newErrors[err.path as keyof typeof formData] = err.message;
                });
                setErrors(newErrors);
            }
        }
    }
    return (
        <div>
            <div className="signin-bg"></div>
            <div className="signin-wrap d-flex">
                <div className="signin-container d-grid">
                    <div className="signin-hero d-flex align-items-start flex-column justify-content-center">
                        <img src={Carwashlogo} alt="Car Wash App" />
                        <h1>{props.userType === userType['SUPER-ADMIN'] ? 'Super Admin' : 'Car Wash Owner'}</h1>
                    </div>
                    <div className="signin-form-wrap password-form-wrap">
                        <h2>Reset Password</h2>
                        <form onSubmit={handleSubmit}>
                            <CWPasswordInput
                                id="newpassword"
                                name="newpassword"
                                type={'password'}
                                label="New Password"
                                placeholder=""
                                showpass={<span />}
                                value={formData.newpassword}
                                maxLength={PASSWORD_MAX_LENGTH}
                                errorMessage={errors.newpassword}
                                autoFocus
                                isMandatory
                                onChange={onPasswordChange}
                            />
                            <CWPasswordInput
                                id="typepassword"
                                name="typepassword"
                                type={'password'}
                                label="Retype Password"
                                placeholder=""
                                showpass={<span />}
                                value={formData.typepassword}
                                maxLength={PASSWORD_MAX_LENGTH}
                                errorMessage={errors.typepassword}
                                isMandatory
                                onChange={onPasswordChange}
                            />
                            <Button
                                title='Submit'
                                type="submit"
                                variant="primary"
                                className="primary-btn"
                            >
                                Submit
                            </Button>
                        </form>
                        <div className="new-user text-center">Back to  <Link to={props.userType == userType['SUPER-ADMIN'] ? `/superadmin/${pageURLs.root}` : '/'} title="Sign In" >Sign In</Link></div>

                    </div>
                </div>
            </div>
            {loading && <FullLoader />}
        </div>
    )
}

export default ForgotPasswordStep3;
